module.exports = __webpack_public_path__ + "img/Icon_Manejo_de_Citas_Provider_Hover.d15d5cc6.svg";